/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Uploadinstruction1Inputs */



/**
* | output |
* | --- |
* | "Select a CSV or Excel file containing alarms to import" |
*
* @param {Alarms_Import_Uploadinstruction1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_import_uploadinstruction1 = /** @type {((inputs?: Alarms_Import_Uploadinstruction1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Uploadinstruction1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select a CSV or Excel file containing alarms to import")
	return /** @type {LocalizedString} */ ("Sélectionnez un fichier CSV ou Excel contenant les alarmes à importer")
});
export { alarms_import_uploadinstruction1 as "alarms_import_uploadInstruction" }